import React, { useEffect } from "react";
import { Container, Header, Nav } from "../styles";
import GoBackButton from "../../../components/goBackButton";
import { FantasyNameAndContractBadge } from "../../../components/badges";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { ContractProductsTitle } from "../ContractProducts/styles";
import { FormattedMessage } from "react-intl";
import { CheckoutContainer, PaymentMethodContainer } from "./styles";
import PaymentSummary from "./components/PaymentSummary";
import { PaymentMethods } from "./components/PaymentMethods";
import { PixMethod } from "./components/PaymentMethods/pix-method";
import { CardMethod } from "./components/PaymentMethods/card-method";
import { CashMethod } from "./components/PaymentMethods/cash-method";
import {
  FormProvider,
  useFormContext,
} from "./components/PaymentMethods/form-context";

function CheckoutComponent() {
  const history = useHistory();
  const { selectedPaymentMethod } = useFormContext();
  const fantasyname = localStorage.getItem("serviceFantasyname");
  const contractNumber = localStorage.getItem("serviceContractNumber");
  const { cartProducts } = useSelector((state) => state.staff_access);

  useEffect(() => {
    if (cartProducts.length === 0) {
      history.push("/staff-access/services/sales");
    }
  }, [history, cartProducts.length]);

  return (
    <Container>
      <Nav>
        <GoBackButton
          noPosition
          href={"/staff-access/services/sales"}
          intlId="backToDashboard"
        />

        <FantasyNameAndContractBadge
          fantasyname={fantasyname}
          contractNumber={contractNumber}
        />
      </Nav>

      <Header>
        <ContractProductsTitle>
          <span>
            <FormattedMessage id={"sales"} />
            {" /"}
          </span>
          <h2>
            <FormattedMessage id={"payment"} />
          </h2>
        </ContractProductsTitle>
      </Header>

      <CheckoutContainer>
        <PaymentMethodContainer>
          <PaymentMethods />

          {selectedPaymentMethod === "pix" && <PixMethod />}
          {selectedPaymentMethod === "card" && <CardMethod />}
          {selectedPaymentMethod === "cash" && <CashMethod />}
        </PaymentMethodContainer>

        <PaymentSummary />
      </CheckoutContainer>
    </Container>
  );
}

export default function Checkout() {
  return (
    <FormProvider>
      <CheckoutComponent />
    </FormProvider>
  );
}
